import PropTypes from 'prop-types';

import TextInput from '#globalComponents/Forms/TextInput';

export const DateInputFilter = ({ id, label, value, onChange, min, max }) => {
	return (
		<div>
			{label && (
				<label htmlFor={id} className="block text-xs text-bgBase-800 mb-1">
					{label}
				</label>
			)}
			<TextInput
				type="date"
				id={id}
				value={value || ''}
				onChange={(e) => onChange(e.target.value)}
				min={min}
				max={max}
			/>
		</div>
	);
};

DateInputFilter.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	min: PropTypes.string,
	max: PropTypes.string,
};
